(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('productList', function ($Products, $state, $uibModal) {
		return {
			scope: {},
			templateUrl: 'directives/productList/table.html',
			link: function() {},
			controller: function($scope) {
				/* Paging items. */
                $scope.products = $Products.all();

                /* Setup the scope data. */
				$scope.search = { name: '' };

				/* Function to provide the option to delete an existing product. */
				$scope.delete = function (item) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Delete this product?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, product) {

                            $scope.delete = function () {

                                scope.products.$remove(item);

                                $uibModalInstance.close(item);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            product: function() {
                                return item;
                            }
                        },
                        size: 'sm'
                    });

		    	};

				/* Function to provide the ability to copy an existing product. */
				$scope.copy = function (item) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Copy ${item.name}?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-success" type="button" ng-click="copy()">Copy</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, product) {

                            $scope.copy = function () {

                                let copy = angular.copy(product);

                                copy.name = 'Copy of ' +  copy.name;

                                scope.products.$add(copy);

                                $uibModalInstance.close(item);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            product: function() {
                                return item;
                            }
                        }
                        // size: 'sm'
                    });

		    	};

				$scope.hasProperty = function(item, key) {
					return  _.chain(item.properties || []).pluck('type').contains(key).value();
				};

				$scope.edit = function(item) {
                    $state.go('product-detail', {id: item.$id});
				};

				$scope.add = function() {
                    $state.go('product-detail');
		        };
			}
		};
	});
})();
